<div class="grid grid-cols-3">
  <ng-container *ngFor="let section of sections">
    <div class="columns-1 border-r border-b border-light-gray1">
      <ng-container *ngFor="let sect of section; let i = index">
        <div [ngClass]="sect.title ? 'border-r border-light-gray1' : 'bg-transparent'"
          class="text-dark-gray1 p-5 3xl:p-8" [ngClass]="{'border-b': i == 0}">
          <h3 [routerLink]="sect.link"
            class="text-xs 3xl:text-[15px] 3xl:leading-[22.5px] font-medium 3xl:font-semibold mb-2 3xl:mb-4"
            [ngClass]="{'cursor-pointer hover:text-teal1 trnsition-colors duration-300 ease-out': sect.link}">{{
            sect.title }}</h3>
          <ng-container *ngFor="let item of sect.items">
            <a class="inline-block mb-2 3xl:mb-3 hover:text-teal1 text-xs 3xl:text-sm cursor-pointer transition-all duration-300 ease-in-out"
              [routerLink]="item.link"
              [fragment]="sect.title === 'NPI' || 'Lab Testing Solutions' || 'Supply Chain Management' ? item.fragment : null">
              {{ item.label }}
            </a><br />
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>